import type LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import type ControlViewModel from '@/ViewModels/ControlViewModel';
import Builder from '@/Builder/Builder';
import { IControlViewModelConstructorParameter } from '#/CoreFrameInterfaces';
import ComponentManager from "@/Management/ComponentManager";

export default abstract class ControlViewModelBuilder<T1 extends ControlViewModel, T2 = null> extends Builder<T1, T2> {

    protected properties: IControlViewModelConstructorParameter;
    protected tooltipBuilder: any;
    protected LabelViewModelBuilder = ComponentManager.getUtility<typeof LabelViewModelBuilder>('LabelViewModelBuilder');

    protected constructor(parent?: T2) {
        super(parent);
        this.properties = {};
    }

    public withIsBusy(isBusy: ObservableOrDefault<boolean>): this {
        this.properties.isBusy= isBusy;
        return this;
    }

    public withIsDisplayed(isDisplayed: ObservableOrDefault<boolean>): this {
        this.properties.isDisplayed = isDisplayed;
        return this;
    }

    public withIsVisible(isVisible: ObservableOrDefault<boolean>): this {
        this.properties.isVisible = isVisible;
        return this;
    }

    public withIsEnabled(isEnabled: ObservableOrDefault<boolean>): this {
        this.properties.isEnabled = isEnabled;
        return this;
    }

    public withIsRequired(isRequired: ObservableOrDefault<boolean>): this {
        this.properties.isRequired = isRequired;
        return this;
    }

    public withIsFocusable(isFocusable: ObservableOrDefault<boolean>): this {
        this.properties.isFocusable = isFocusable;
        return this;
    }

    public withInvalidationText(invalidationText: ObservableOrDefault<string>): this {
        this.properties.invalidationText = invalidationText;
        return this;
    }

    public withIsValid(isValid: ObservableOrDefault<boolean>): this {
        this.properties.isValid = isValid;
        return this;
    }

    public withIsActive(isActive: ObservableOrDefault<boolean>): this {
        this.properties.isActive = isActive;
        return this;
    }

    public withTooltip(): LabelViewModelBuilder<this> {
        if (this.tooltipBuilder == null) {
            this.tooltipBuilder = new this.LabelViewModelBuilder(this);
        }

        return this.tooltipBuilder;
    }

    public withTooltipErgName(ergName: ObservableOrDefault<string>): this {
        return this.withTooltip().withErgName(ergName).done();
    }

    public withParentLocator(parentLocator: ObservableOrDefault<string>): this {
        this.properties.parentLocator = parentLocator;
        return this;
    }

    public withLocator(locator: ObservableOrDefault<string>): this {
        this.properties.locator = locator;
        return this;
    }

    protected preBuild(): void {
        // Automatisches Durchreichen der Locator
        if (this.parent != null && this.parent instanceof ControlViewModelBuilder)
            this.properties.parentLocator = this.parent.properties.locator;

        if (this.tooltipBuilder != null)
            this.properties.tooltip = this.tooltipBuilder.build();
    }
}